<template>
  <div class="cargo-help">
    <h2 class="vz-text-align-left">
      Часто задаваемые вопросы
    </h2>
    <vz-collapse-info v-for="item in items">
      <template #header>
        <span>{{ item.question }}</span>
      </template>
      <span v-html="item.answer" />
      <nuxt-link v-if="item.link" :to="item.link.to" class="ml-5">
        {{ item.link.title }}
      </nuxt-link>
      <span v-if="item.answerEnd" v-html="item.answerEnd" />
    </vz-collapse-info>
  </div>
</template>

<script setup lang="ts">
import VzCollapseInfo from '~~/components/ui-kit/vz-collapse-info.vue'
import { getDocuments } from '~~/api/document'

const doc = ref('')

const items = computed(() => {
  return [
    {
      question: 'Как рассчитать стоимость грузоперевозки?',
      answer: 'Предварительную стоимость можно рассчитать в калькуляторе перевозки. Полную стоимость можно определить в',
      link: {
        title: 'форме расчета',
        to: '/order/create'
      },
      answerEnd: ', на основании веса, объема груза, расстояния, направления и множества других параметров груза.',
    },
    {
      question: 'Какие грузы можно отправить?',
      answer: `Можно отправить любые грузы через нашу транспортную компанию, кроме <a href="${doc.value}" target="_blank">запрещенных к перевозке</a>.`,
    },
    {
      question: 'Какие грузы не принимаются к перевозке?',
      answer: `Опасные грузы, запрещенные препараты, любое оружие и боеприпасы, драгметаллы, деньги, драгоценные камни, все растения и животные, а также грузы, требующие определенный температурный режим. <a href="${doc.value}" target="_blank">Полный список.</a>`,
    },
    {
      question: 'Каким транспортом перевозятся грузы?',
      answer: 'Мы используем для перевозки следующий автотранспорт: грузовая машина с верхней и боковой загрузкой, машина с открытым кузовом, машина с задней загрузкой без гидроборта, гидроборт, автомобиль с растентовкой и манипуляторы.',
    },
    {
      question: 'Какие документы необходимы для отправки груза?',
      answer: 'Физ.лицам: Документ, удостоверяющий личность, Опись груза. Компаниям: Доверенность, подтверждающая полномочия или Свидетельство о государственной регистрации ИП для индивидуальных предпринимателей, Паспорт отправляющего сотрудника, Документы на груз (ТН, ТТН, сертификат)',
    },
    {
      question: 'Как отслеживать статус моего груза?',
      answer: 'Вы можете отслеживать статус груза в личном кабинете или',
      link: {
        title: 'в этом разделе',
        to: '/order/manage'
      }
    },
    {
      question: 'Как заказать транспортировку?',
      answer: 'Сделайте расчет в калькуляторе доставки и отправьте форму расчета. Или зарегистрируйте в личном кабинете и сделайте заказ. Также можно привезти груз на один из терминалов или сделать заказ в мобильном приложении Возовоз.',
    },
    {
      question: 'Какой груз считается негабаритным?',
      answer: 'Груз является негабаритным, если длина груза больше или равна 4 м или вес больше 500 кг, а габариты длина*ширина*высота больше, чем 1,2*0,8*1,75 м.',
    },
    {
      question: 'Где передать груз для отправки?',
      answer: 'Груз можно передать для отправки на терминале или на адресе отправления при адресной доставке.',
    },
  ]
})

await getDocuments({documents: ['not-allowed-for-transportation-vz']}).then(docs => {
  doc.value = docs['not-allowed-for-transportation-vz']?.fileUrl || docs['not-allowed-for-transportation-vz']?.url || '/documents/'
})
</script>
